export const SET_SCANFILTER = 'SET_SCANFILTER';

export function setScanFilter(filter) {
  return {
    type: SET_SCANFILTER,
    payload: filter,
  };
}
